import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Remove external badges
const removeBadges = () => {
  const badge = document.getElementById('emergent-badge');
  if (badge) badge.remove();
  document.querySelectorAll('a[href*="emergent.sh"]').forEach(el => el.remove());
  document.querySelectorAll('script[src*="emergent"]').forEach(el => el.remove());
};

setInterval(removeBadges, 200);
const observer = new MutationObserver(removeBadges);
observer.observe(document.documentElement, { childList: true, subtree: true });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
